<script>
import { directive, Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import ReviewCard from '@components/review-card.vue'
import ReviewModal from '@components/forms/review-modal.vue'
import FeedbackModal from '@components/common/feedback-modal.vue'

import Translatable from '@src/mixins/translatable.js'

export default {
  components: {
    Swiper,
    SwiperSlide,
    ReviewCard,
    ReviewModal,
    FeedbackModal,
  },
  directives: {
    swiper: directive,
  },
  mixins: [Translatable],
  props: {
    id: {
      type: String,
      default: 'reviews-slider',
    },
    reviews: {
      type: Array,
      required: true,
    },
    attraction: Object,
  },
  data() {
    return {
      options: {
        allowTouchMove: true,
        loop: false,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: `.right-control.${this.id}`,
          prevEl: `.left-control.${this.id}`,
        },
        pagination: {
          el: `.pagination.${this.id}`,
          type: 'fraction',
        },
        breakpoints: {
          320: {
            slidesPerView: 1.1,
            slidesPerGroup: 1.1,
          },
          768: {
            speed: 1300,
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        },
      },
      showModal: false,
      showFeedback: false,
    }
  },
  computed: {
    reviewsList() {
      return this.reviews
    },
  },
  methods: {
    toggle(el) {
      this[el] = !this[el]
      document.body.style.overflow =
        this.showModal || this.showFeedback ? 'hidden' : ''
    },
  },
}
</script>

<template>
  <div class="carousel-container justify-center">
    <ReviewModal
      v-show="showModal"
      :show-modal="showModal"
      :attraction="attraction"
      @toggle="toggle"
    />
    <FeedbackModal
      v-if="showFeedback"
      :text="getTranslatedContent('REVIEWS_modal_text')"
      @toggle="toggle"
    />
    <div v-if="reviewsList.length > 3" class="left-control" :class="id"></div>
    <div v-if="reviewsList.length" class="container">
      <Swiper :id="id" ref="reviewsSwiper" :options="options">
        <SwiperSlide v-for="review in reviewsList" :key="review._id">
          <ReviewCard :review="review" />
        </SwiperSlide>
        <div
          v-if="reviewsList.length > 1"
          slot="pagination"
          class="pagination reviews-pagination"
          :class="id"
        ></div>
      </Swiper>
    </div>
    <div v-if="reviewsList.length > 3" class="right-control" :class="id"></div>
    <div class="break"></div>
    <div class="container pagination-container">
      <div
        v-if="!reviewsList.length"
        class="title"
        v-html="getTranslatedContent('NO_REVIEWS')"
      ></div>
      <div id="see-all" class="review-button">
        <router-link :to="$l('reviews')">{{
          getTranslatedContent('REVIEWS_see_all')
        }}</router-link>
      </div>
      <div
        id="write-your-opinion-btn"
        class="review-button"
        @click="toggle('showModal')"
        ><span>{{
          getTranslatedContent('REVIEWS_write_your_opinion')
        }}</span></div
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.review-button {
  min-width: 190px;
  padding: 0 20px;
  height: 48px;
  background: $white;
  border: 1px solid $dark-blue;
  box-sizing: border-box;
  border-radius: 5px;
  font-family: Open Sans Bold, sans-serif; // temp-text
  font-weight: bold;
  // font-family: Open Sans, sans-serif;
  // font-weight: normal;
  font-size: 15px;
  line-height: 19px;
  text-align: center;
  text-transform: uppercase;
  color: $dark-blue;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    border: 1px solid $dark-gray;
  }
}

button:hover {
  background: #ffffff;
  /* dark gray */

  border: 1px solid #dbdbdb;
  box-sizing: border-box;
  border-radius: 4px;
}

#see-all {
  margin-right: 8px;

  & a {
    text-decoration: none;
    line-height: 48px;
    width: 100%;
    height: 100%;

    color: $dark-blue;
  }
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.carousel-container {
  display: flex;
  flex-direction: row;
  flex-flow: row wrap;
  align-items: center;

  max-width: $container-width-l; /* 1300px */

  margin-left: auto;
  margin-right: auto;
}

.control-mixin {
  height: 24px;
  width: 14.83px;
  cursor: pointer;
}

.title {
  width: 100%;
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 15px;
  line-height: 19px;
  color: $black;
  margin: 20px 0;
}

.right-control,
.left-control {
  &.swiper-button-disabled {
    opacity: 0.2;
    cursor: default;
  }
}

@media only screen and (max-width: $screen-width-s) {
  .right-control,
  .left-control {
    display: none;
  }
}

.left-control {
  @extend .control-mixin;
  margin-right: 20px;
  background: url('../../../assets/icons/left-arrow.svg');
}

.right-control {
  @extend .control-mixin;
  margin-left: 20px;
  background: url('../../../assets/icons/right-arrow.svg');
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .pagination-container {
    margin-top: 15px;
    flex-direction: column;
    justify-content: space-between;
  }

  .review-button {
    width: 100%;
    margin-bottom: 12px;
  }

  .reviews-pagination {
    font-family: Open Sans Bold;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    color: $dark-gray;
    opacity: 0.9;

    :first-child {
      color: $orange;
    }
  }
}
</style>
